// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, Input } from '@angular/core';

@Component({
  selector: 'e-popup-buttons',
  templateUrl: './popup-buttons.component.html',
  styleUrls: ['./popup-buttons.component.scss'],
})
export class PopupButtonsComponent {
  @Input() align = 'left';
}
